<div class="card">
  <div class="hd">
    <div class="title">Alertes & Statuts</div>
    <span class="badge">Aucune alerte</span>
  </div>
  <div class="body">
    <ul style="margin:0; padding-left:18px;">
      @for (alert of alerts; track $index) {
        <li class="title">Version {{ alert.version }} ({{ alert.date }})</li>
        @if (alert?.changes?.length) {
          <ul style="margin:0; padding-left:18px;">
            @for (change of alert.changes; track $index) {
              <li>{{ change }}</li>
            }
          </ul>
        }
      }
    </ul>
  </div>
</div>
